class MapContainer extends HTMLElement {
    constructor() {
        super();

        this.markerImage = window.mapMarkerImage ?? "https://cdn.shopify.com/s/files/1/0573/9760/8523/files/icon-yl-marker.png";
        console.log(this.markerImage);


        this.markersPositions = [];
        this.mapStyle = [
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e9e9e9"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 29
                    },
                    {
                        "weight": 0.2
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 18
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dedede"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "saturation": 36
                    },
                    {
                        "color": "#333333"
                    },
                    {
                        "lightness": 40
                    }
                ]
            },
            {
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    },
                    {
                        "lightness": 19
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 17
                    },
                    {
                        "weight": 1.2
                    }
                ]
            }
        ];
    }

    // Called when the custom element is added to the DOM
    async connectedCallback() {
        const apiKey = this.getAttribute('data-api-key');
        const mapData = window.mapData || [];

        if (!apiKey) {
            console.error('Google Maps API key is missing.');
            return;
        }

        try {
            await this.loadGoogleMapsAPI(apiKey);
            await this.initializeMap(mapData);
        } catch (error) {
            console.error('Failed to initialize map:', error);
        }
    }

    /**
     * Loads the Google Maps API dynamically
     * @param {string} apiKey - Google Maps API key
     * @returns {Promise<void>}
     */
    loadGoogleMapsAPI(apiKey) {
        return new Promise((resolve, reject) => {
            // If the API is already loaded, resolve immediately
            if (window.google && window.google.maps) {
                resolve();
                return;
            }

            // Dynamically load the Google Maps script
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
            script.async = true;
            script.defer = true;

            script.onload = () => resolve();
            script.onerror = () => reject(new Error('Google Maps API failed to load'));

            document.head.appendChild(script);
        });
    }

    /**
     * Initializes the map and adds markers
     * @param {Array} mapData - Array of location data
     */
    async initializeMap(mapData) {
        const mapElement = this.querySelector('#map');
        if (!mapElement) {
            console.error('Map container element (#map) is missing.');
            return;
        }

        // Initialize the Google Map
        const map = new google.maps.Map(mapElement, {
            center: { lat: 45.55, lng: -73.8 }, // Default center (Laval, QC)
            zoom: 12,
            styles: this.mapStyle, // Apply the style here
            disableDefaultUI: true, // Disable all default controls
            zoomControl: true, // Enable zoom control only
            mapTypeControl: false, // Disable satellite/terrain options
            streetViewControl: false, // Disable Street View pegman
            fullscreenControl: false, // Disable fullscreen button
        });

        const bounds = new google.maps.LatLngBounds();
        const geocodePromises = [];

        mapData.forEach(location => {
            if (location.address) {
                geocodePromises.push(this.addMarkerByAddress(location, map, bounds));
            } else if (location.latitude && location.longitude) {
                const position = {
                    lat: parseFloat(location.latitude),
                    lng: parseFloat(location.longitude),
                };
                this.markersPositions.push(position);
                this.addMarker(position, map, bounds, location);
            } else {
                console.warn('Location data is incomplete:', location);
            }
        });

        // Wait for all geocoding requests to complete
        await Promise.all(geocodePromises).catch(err => console.error("One or more geocoding requests failed", err));

        // Adjust the map to fit all markers
        if (this.markersPositions.length > 1) {
            map.fitBounds(bounds);
        } else if (this.markersPositions.length === 1) {
            map.setCenter(this.markersPositions[0]);
            map.setZoom(13); // Zoom in closer for a single marker
        }
    }

    /**
     * Adds a marker to the map using latitude and longitude
     * @param {Object} position - { lat, lng }
     * @param {Object} map - Google Map instance
     * @param {Object} bounds - LatLngBounds instance
     * @param {Object} location - Location data object
     */
    addMarker(position, map, bounds, location) {
        const marker = new google.maps.Marker({
            position,
            map,
            title: location.title || location.label,
            icon: {
                url: this.markerImage, // image URL
                scaledSize: new google.maps.Size(32, 32), // desired size in pixels
            }
        });

        const headerEl = document.createElement('p');
        headerEl.className = 'tw-text-lg tw-font-medium tw-leading-none';
        headerEl.textContent = location.title || location.label;

        const infoWindow = new google.maps.InfoWindow({
            maxWidth: 250,
            ariaLabel: location.title || location.label,
            headerContent: headerEl,
            content: `
                <div class="tw-py-2">
                    <a class="tw-button tw-button-link hover:tw-underline" href="https://www.google.com/maps/search/?api=1&query=${location.address}" target="_blank">${location.address}</a>
                </div>
            `
        });

        marker.addListener('click', () => {
            infoWindow.open({
                anchor: marker,
                map,
            });
        });

        bounds.extend(marker.getPosition());
    }

    /**
     * Adds a marker to the map using an address (geocoded to lat/lng)
     * @param {Object} location - Location data object
     * @param {Object} map - Google Map instance
     * @param {Object} bounds - LatLngBounds instance
     */
    addMarkerByAddress(location, map, bounds) {
        return new Promise((resolve, reject) => {
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ address: location.address }, (results, status) => {
                if (status === 'OK') {
                    const position = results[0].geometry.location;
                    this.markersPositions.push(position);
                    this.addMarker(position, map, bounds, location);
                    resolve();
                } else {
                    console.error(`Geocoding failed for address "${location.address}": ${status}`);
                    reject(new Error(`Geocoding failed for address "${location.address}": ${status}`));
                }
            });
        });
    }
}

// Define the custom element if not already defined
if (!customElements.get('map-container')) {
    customElements.define('map-container', MapContainer);
}
